import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-form-field-filter',
    templateUrl: './form-field-filter.component.html',
    styleUrls: ['./form-field-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldFilterComponent implements OnInit {

  @Input() configData;
  @Input() frmGroup;

  constructor() { }

  ngOnInit() {
    console.log(this.configData);
    console.log(this.frmGroup);
  }

  getFormTableControls(){
    return this.frmGroup.controls[this.configData.name]['controls'];                
  }  

  getColsClass(cols: number[]) {
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for (let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }
    return colsClass;
  }
  
}
